import { createSignal } from "solid-js"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useIsMapControlActiveSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<boolean>(false)

  return signal
})


